import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
    locations: null,
    error: null,
    loading: false,
};

// Get Location
const getLocationStart = (state: any, action: any) => {
    return updateObject(state, { error: null, loading: true });
};

const getLocationSuccess = (state: any, action: any) => {    
    return updateObject(state, {
        locations: action.locations,
        error: null,
        loading: false,
    });
};

const getLocationFailed = (state: any, action: any) => {
    return updateObject(state, {
        error: action.error,
        loading: false,
        locations: null
    });
};

const locationReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.GET_LOCATION_START:
            return getLocationStart(state, action);
        case actionTypes.GET_LOCATION_SUCCESS:
            return getLocationSuccess(state, action);
        case actionTypes.GET_LOCATION_FAIL:
            return getLocationFailed(state, action);
        default:
            return state;
    }
};

export default locationReducer;